import React from 'react';
import './KaizenCard';

import Kaizen from './Assets/Kaizen.gif';

const KaizenCard = () => {
  return (
    <div className="kaizen-container">
      <div className="grid-box">
        <div className="circle-container">
  <div className="circle Business"><p>Business Excellence</p></div>
  <div className="circle operational"><p>Operational Excellence</p></div>
  <div className="circle process"><p>Process Excellence</p></div>
</div>

                       
        {/* Business Model Box */}
        <div className="card1">
          <h2>We'll help perfect your business model.</h2>
          <p>
            Team up with us to fine-tune your business model with a sprinkle of our expert magic solutions.
          </p>
        </div>

      </div>
    </div>
  );
};

export default KaizenCard;